import axios from 'axios'
import CONFIG from '../config.js'

import takeFirstResult from '@/api/util/takeFirstResult'
import flattenACF from '@/api/util/flattenACF'
import normalizeWordpress from '@/api/util/normalizeWordpress'
import transformLocalizationInfo from '@/api/util/transformLocalizationInfo'
import transformFlexContent from '@/api/util/transformFlexContent'
import transformPostMeta from '@/api/util/transformPostMeta'

export default function getHomeData ({ lang = 'de-ch', slug = 'about' }) {
	return new Promise((resolve, reject) => {
		return axios.get(`${CONFIG.API_URL}/wp/v2/pages?slug=${slug}${lang === 'en-us' ? '&lang=en' : '&lang=de'}`, {
			transformResponse: [].concat(
				axios.defaults.transformResponse,
				takeFirstResult,
				normalizeWordpress,
				flattenACF,
				transformLocalizationInfo,
				transformFlexContent,
				transformPostMeta
			)
		})
		.then(response => {
			// console.log(response.data)
			const { data } = response
			;(data && data.id) ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' })
		})
		.catch(response => reject(response))
	})
}



// WEBPACK FOOTER //
// ./src/api/about.wp.api.js